import { Spinner } from "@/components/ui/spinner"

export const UiFullscreenSpinner = () => {
  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner className="h-10 w-10" />
    </div>
  )
}
